<template>
    <section>
        <div class="custom-file-input logo">
            <input class="upload-input" type="file" accept="image/png, image/jpeg"
                   ref="inputFile"
                   @change="onFileChange" />
            <img :src="imagePreview" alt="" class="upload-img" :class="{checkerboard: showCheckerboard}">
            <div id="fileDrag">Choose a file or drop one here</div>
        </div>
        <label v-if="displayLabel">{{ label }} <small class="text-light">{{ subText }}</small></label>
    </section>

</template>

<script>
    export default {
        props: {
            logo: {
                default: null,
                type: Object
            },
            label: {
                default: 'Logo',
                type: String
            },
            displayLabel: {
                default: true,
                type: Boolean
            },
            subText: {
                default: "(Max: 125mb JPG, PNG, GIF, SVG)",
                type: String
            },
            showCheckerboard: {
                default: true,
                type: Boolean
            }
        },
        computed: {
            imagePreview:  function(){
                if (this.newLogo) {
                    return this.newLogo;
                }
                if (this.logo && this.logo.location) {
                    if(this.logo.location.substring(0, 4) === 'http') {
                        return this.logo.location;
                    }
                    return `${process.env.VUE_APP_CDN_URL}${this.logo.location}`;
                }
                return "";
            }
        },
        data () {
            return {
                uploadFile: {},
                newLogo: null
            }
        },
        methods: {
            onFileChange () {
                this.uploadFile = this.$refs.inputFile.files[0];
                this.getImagePreview();
                this.$emit('logoupload', true);
            },
            getImagePreview () {
                let reader = new FileReader();
                reader.addEventListener("load", function() {
                    this.newLogo = reader.result;
                }.bind(this), false);
                if (this.uploadFile) {
                    if (/\.(jpe?g|png|gif|svg)$/i.test(this.uploadFile.name)) {
                        reader.readAsDataURL(this.uploadFile);
                    }
                }
            },
        },
    }
</script>
